import { useEffect, useState } from 'react';

const RECAPTCHA_SITE_KEY = '6LfdoEgrAAAAALg4NMmdACxKsI9BKCNPEkoi1rP0'; //TODO: Move to env

export function useRecaptchaReady() {
  const [reCaptchaIsReady, setReCaptchaIsReady] = useState(false);

  useEffect(() => {
    const scriptSelector = `script[src="https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}"]`;
    const existingScript = document.querySelector<HTMLScriptElement>(scriptSelector);
    const script = existingScript ?? document.createElement('script');

    if (!existingScript) {
      script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
      script.async = true;
      document.body.appendChild(script);
    }

    const checkRecaptcha = setInterval(() => {
      if (window.grecaptcha && window.grecaptcha.ready) {
        window.grecaptcha.ready(() => {
          setReCaptchaIsReady(true);
        });
        clearInterval(checkRecaptcha);
      }
    }, 100);

    return () => {
      clearInterval(checkRecaptcha);
      if (!existingScript && document.body.contains(script)) {
        document.body.removeChild(script);
      }
      document.querySelectorAll('.grecaptcha-badge').forEach((badge) => badge.remove());
    };
  }, []);

  return reCaptchaIsReady;
}